export default __webpack_public_path__ + "static/media/no-cigarette.9bb9be18.png";